import { useNavigate } from 'react-router';
import { Button, Result } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { getHomePathByUser } from '@/utils/common';
import { useAuthStore } from '@/store/auth';

const ForbiddenPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { currentUser } = useAuthStore();

  return (
    <Result
      status="403"
      title="403"
      subTitle={t('pages.403.subTitle')}
      extra={
        <Button
          type="primary"
          onClick={() => navigate(currentUser ? getHomePathByUser(currentUser) : '/')}
        >
          {t('backHome')}
        </Button>
      }
    />
  );
};

export default ForbiddenPage;
